<template>
  <div class="page-item">
    <div class="item line" v-for="item in list" :key="item.Id">
      <FormworkOne :hasIntroduction="false" hasFollow :row="item"></FormworkOne>
      <div>
        <van-button v-if="item.ChangeCard" class="btn" size="mini" @click="showCardFunc(item)">查看名片</van-button>
        <van-button v-if="item.Both && item.isFollow" class="btn" size="mini" @click="handleClick(item)">互相关注</van-button>
        <van-button v-else :type="item.isFollow?'default':'primary'" class="btn" size="mini" @click="handleClick(item)">{{item.isFollow?'已关注':'+关注'}}</van-button>
      </div>
    </div>
    <EmptyPosition v-show="!list.length" type="follow"></EmptyPosition>
    <card :show.sync="showCard" :userId="cardUserId" />
  </div>
</template>

<script>
import FormworkOne from '../components/formworkOne'
import EmptyPosition from '@/components/common/emptyPosition'
import card from '@/components/card/card'
import { Cms } from '@/api'

export default {
  name: "follow",
  components: { FormworkOne, EmptyPosition, card },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showCard: false,
      cardUserId: 0
    }
  },
  methods: {
    handleClick(item) {
      this.$api(Cms.FollowToggleFollow, { UserId: this.$mdUtils.getUserInfo('Id'), FollowedUserId: item.UserId })
        .then(() => {
          if (item.isFollow) {
            item.isFollow = false
            item.Author.FollowedQuantity -= 1
          } else {
            item.isFollow = true
            item.Author.FollowedQuantity += 1
          }
          this.$mdUtils.commitRemoveKeepAlive(['followArticle'])
          this.$emit('onChange', item)
        })
    },
    showCardFunc(item) {
      this.cardUserId = item.UserId
      this.showCard = true
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding-right: 20px;
  padding: 25px;
}
.btn {
  flex: none;
}
</style>

